var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#225E96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 19.6406V18.375C36 16.9253 34.8248 15.75 33.375 15.75H14.625C13.1753 15.75 12 16.9253 12 18.375V19.6406C12 19.77 12.105 19.875 12.2344 19.875H35.7656C35.895 19.875 36 19.77 36 19.6406Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.6094V29.625C12 31.0747 13.1753 32.25 14.625 32.25H33.375C34.8248 32.25 36 31.0747 36 29.625V21.6094C36 21.48 35.895 21.375 35.7656 21.375H12.2344C12.105 21.375 12 21.48 12 21.6094ZM18 27.75C18 28.1642 17.6642 28.5 17.25 28.5H16.5C16.0858 28.5 15.75 28.1642 15.75 27.75V27C15.75 26.5858 16.0858 26.25 16.5 26.25H17.25C17.6642 26.25 18 26.5858 18 27V27.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayCard);
export default __webpack_public_path__ + "static/media/pay-card.1a98dbeb46b6645414350666480ff862.svg";
export { ForwardRef as ReactComponent };